import CryptoJS from 'crypto-js';

const validateAuthToken = ({ name, timestamp, token, secretKey = '4for4-betting-user' }) => {
  const tokenData = {
    name: name || 'anonymous',
    hour: timestamp,
  };

  let computedToken = CryptoJS.HmacSHA256(
    JSON.stringify(tokenData),
    secretKey
  ).toString(CryptoJS.enc.Base64);

  computedToken = computedToken
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=/g, '');

  return computedToken === token;
};

// Function to get query string parameters and validate
export const checkUserAuth = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const name = urlParams.get('name') || 'anonymous';
  const timestamp = urlParams.get('timestamp');
  const token = urlParams.get('token');
  const plan = urlParams.get('plan');
  const isInIframe = window.self !== window.top;
  
  console.log('Auth check params:', { name, timestamp, token, plan, isInIframe });
    //   if (!isInIframe) {
    //   // For development/testing when not in iframe
    //   return { isValid: true, name: 'SharpStackUser', reason: 'dev-mode' };
    // }
  //If no auth params provided, return as unauthenticated guest
  if (!timestamp && !token && !plan) {
    console.log('No auth parameters provided - guest user');
    return { isValid: false, name: '', reason: 'no-params' };
  }
  
  // If partial auth params, it's an invalid auth attempt
  if (!name || !timestamp || !token || !plan) {
    console.log('Missing some auth parameters');

    return { isValid: false, name: null, reason: 'missing-params' };
  }

  // Validate the token
  let isValid = validateAuthToken({
    name,
    timestamp,
    token,
    plan,
    secretKey: '4for4-betting-user',
  });

  // Check if user doesn't have betting plan
  // if (plan && !plan.includes('betting')) {
  //   console.log('User does not have betting plan:', plan);
  //   return { isValid: false, name: name, reason: 'no-betting-plan', plan: plan };
  // }

  // Additional validation rules
  if (name === 'anonymous') {
    isValid = false;
  }
  
  console.log('Token validation result:', isValid);
  return { isValid, name: isValid ? name : null, reason: isValid ? 'success' : 'invalid-token' };
};

// Function to force refresh after 24 hours
export const forceRefreshIfExpired = (timestamp) => {
  const currentTime = new Date();
  const timestampDate = new Date(
    parseInt(timestamp.slice(0, 4)), // Year
    parseInt(timestamp.slice(4, 6)) - 1, // Month (0-based)
    parseInt(timestamp.slice(6, 8)), // Day
    parseInt(timestamp.slice(8, 10)) // Hour
  );
  const hoursDiff = (currentTime - timestampDate) / (1000 * 60 * 60);
  if (hoursDiff >= 24) {
    console.log('Token expired, forcing refresh');
    window.location.reload(); // Or redirect to 4for4 login
  }
};